// extracted by mini-css-extract-plugin
export default {"orders":"Rerouting_orders__xRnYE","footer":"Rerouting_footer__rgAM2","footerPanel":"Rerouting_footerPanel__u8IoR","content":"Rerouting_content__PD+JB"};